up.compiler('[styled-alert]', (element, { text }) => {

  function onClick() {
    const content = up.element.createFromSelector('div')

    up.element.affix(content, 'h4', { text: 'Hinweis' })

    text.split(/\n+/).forEach((line) => up.element.affix(content, 'p', { text: line }))

    up.element.affix(content, 'button.btn.btn-light[type="button"][up-dismiss]', { text: 'Schließen' })

    up.layer.open({
      mode: 'modal',
      size: 'small',
      content,
    })
  }

  element.addEventListener('click', onClick)

})
